(function ($, Cobalt, undefined) {
    Cobalt.ForumThreadForm =
    {
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User" }, { dependency: Cobalt.Markup, name: "Cobalt.Markup" }, { dependency: Cobalt.UI, name: "Cobalt.UI" }, { dependency: Cobalt.Forms, name: "Cobalt.Forms" }];
        },
        initialize: function () {

            // prevent weird behavior on "enter" on this form.
            $("form.j-thread-form input").bind("keypress", function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                }
            });

            var $fieldType = $(".forum-create, .j-thread-form").find(".j-forum-thread-type");
            $fieldType.change(function () {
                if ($(this).val() === "3") {
                    $(".j-toggle-announcement-form").show();
                }
                else {
                    $(".j-toggle-announcement-form").hide();
                    $(".j-announcement-form").hide();
                }
            });

            var _isInitial = true;
            $(".j-show-poll-button").click(function (e, isInitial) {
                if (!$(".j-poll div").length) {
                    $(".j-add-poll-button").trigger("click");
                }
                if (_isInitial) {
                    return;
                }
                var currentValue = $(".j-attach-poll").val() == "y";
                $(".j-attach-poll").val(currentValue ? "n" : "y")
            });

            Cobalt.runOnHtmlInsert(function () {
                $fieldType.change(true);
                if ($(".j-attach-poll").val() == "y" && $(".p-poll-form-a").is(":hidden")) {
                    $.log("Showing poll form");
                    $(".j-show-poll-button").trigger("click");
                }
                _isInitial = false;
            });
            $("#field-submit").click(function (e) {
                if ($(this).parents(".j-thread-form").valid()) {
                $(".p-forum").mask();
                }
            });

        }
    };

})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ForumThreadForm.js